// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jarvis__react-shell-onboarding-center .text-box-style input {\n  text-transform: uppercase;\n}", "",{"version":3,"sources":["webpack://./src/components/styles.scss"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B","sourcesContent":[".jarvis__react-shell-onboarding-center .text-box-style input {\n  text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
